module.exports = __webpack_public_path__ + "img/iso-27001.c6420c8.webp";